<ng-template #reporteConfirmacion>
    <h1 mat-dialog-title>Su sesión ha expirado</h1>
    <div mat-dialog-content>Su sesión será cerrada por inactividad</div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close>Cerrar</button>
        <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    </div>
</ng-template>
